import styled from 'styled-components'

import TextArea from 'components/TextArea'
import RadioButton from 'components/RadioButton'
import Caption from 'components/Caption'

export const CertificateTextArea = styled(TextArea)`
  height: 90px;
`

export const SamlRadioButton = styled(RadioButton)`
  margin: 8px 16px 8px 0;
`

export const StyledCaption = styled(Caption)`
  margin-top: 6px; /* stylelint-disable-line scales/space */
  font-size: ${({ theme }) => theme.fontSizes.little};
`
